export const IS_MOCK = import.meta.env.DEV && import.meta.env.VITE_USE_MOCK_API === "true";

const configuredProject = import.meta.env.VITE_FIREBASE_PROJECT_ID;
export const IS_PRODUCTION = configuredProject === "ottagive-prod";
export const DEPLOYMENT_ENVIRONMENT = IS_PRODUCTION ? "production" : "development";
export const DEPLOYMENT_KEY = IS_PRODUCTION ? "prod" : "dev";
export const DEPLOYMENT_LABEL = IS_PRODUCTION ? "PROD" : "DEV";
export const DEPLOYMENT_NAME = IS_PRODUCTION ? "production" : "development";
export const EXPECTED_PORTAL_HOST = IS_PRODUCTION ? "admin.ottagive.com" : "admin-dev.ottagive.com";
export const EXPECTED_FIREBASE_PROJECT = IS_PRODUCTION ? "ottagive-prod" : "ottagive-dev";
export const EXPECTED_API_HOST = IS_PRODUCTION ? "api.ottagive.com" : "api-dev.ottagive.com";

export function assertBrowserEnvironment(): void {
  if (import.meta.env.DEV) return;
  if (window.location.protocol !== "https:" || window.location.hostname !== EXPECTED_PORTAL_HOST) {
    throw new Error(`This build is restricted to https://${EXPECTED_PORTAL_HOST}`);
  }
  if (import.meta.env.VITE_FIREBASE_PROJECT_ID !== EXPECTED_FIREBASE_PROJECT) {
    throw new Error(`Firebase project mismatch: expected ${EXPECTED_FIREBASE_PROJECT}`);
  }
  if (import.meta.env.VITE_USE_MOCK_API === "true") {
    throw new Error("Mock API cannot be enabled in a production build");
  }
}
